export default "__VITE_ASSET__2JO$ZkFo__"